module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAq0lEQVQoU42QOwrCQBiEv5UVA0ltxK0s7WwtvYWlrWewEMkd7Expp4gnsPEOtkIeHmAhQUwiiwjmQfAvh29+Zkbw54kS56gbWb4iiQ9Vfxm01YQOJ4rCR0ceUHwNZdCodt9FdI9AgBYLCBIj18HPix7OcAdijA6nwLMZtNwRUp6BKzpcmgh10BrMkHIPuYeOts0ZHWXca17ZnPRx+W1ebe2T5RvS+N4+T8v4b5rHLAtU+apCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/toRight.png
// module id = E+TT
// module chunks = 1